module.exports = __webpack_public_path__ + "assets/plus_icon.png?2fa72d6af681ef282816768aa7739dee";